import React, { useEffect, useState } from "react";
import Loading from "../../components/Loading";
import { Link } from "react-router-dom";
import { Eye, Trash2 } from "lucide-react";
import { Badge, Button } from "flowbite-react";
import toast from "react-hot-toast";

export const ORDER_OUTLINE = [
  { api_name: "uid", show_name: "Temp. Order Id" },
  { api_name: "Delivery_Date", show_name: "Delivery Date" },
  { api_name: "Grand_Total", show_name: "Total" },
  { api_name: "status", show_name: "Status" },
];

const OrderLists = () => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Fetch drafted orders from local storage
    const loadDraftedOrders = () => {
      const draftedOrders = [];
      for (let key in localStorage) {
        if (key.startsWith("order_")) {
          const order = JSON.parse(localStorage.getItem(key));
          // convert order id
          order["uid"] = order["uid"].replace("order_", "");
          draftedOrders.push(order);
        }
      }
      setOrders(draftedOrders);
      setIsLoading(false);
    };

    loadDraftedOrders();
  }, []);

  const handleDeleteOrder = (orderId) => {
    // Remove from local storage
    localStorage.removeItem(`order_${orderId}`);
    // Update state
    setOrders((prevOrders) =>
      prevOrders.filter((order) => order.uid !== orderId)
    );
    // Show success toast
    toast.success("Order successfully removed!");
  };

  return (
    <>
      <div className="flex justify-between">
        <h2 className="text-2xl font-bold text-gray-700">Drafted Orders</h2>

        <Link to={"/purchase-order/new"}>
          <Button color="blue" size="xs">
            Create New Request Order
          </Button>
        </Link>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <div className="flex justify-between items-center mb-4"></div>
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              {ORDER_OUTLINE.map(({ show_name }) => (
                <th
                  key={show_name}
                  scope="col"
                  className="px-6 py-3 text-center"
                >
                  {show_name}
                </th>
              ))}

              <th scope="col" className="px-6 py-3 text-center">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td
                  colSpan={(ORDER_OUTLINE.length ?? 0) + 1}
                  className="text-center py-6"
                >
                  <Loading />
                </td>
              </tr>
            ) : orders && orders.length > 0 ? (
              orders.map((order) => (
                <tr
                  key={order?.id}
                  className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  {ORDER_OUTLINE.map(({ api_name }) => {
                    if (api_name === "status")
                      return (
                        <td
                          key={Math.random()}
                          className="px-6 py-4 max-w-32 overflow-x-auto custom-scrollbar"
                        >
                          <span className="inline-block">
                            <Badge color="failure">Draft</Badge>
                          </span>
                        </td>
                      );

                    return (
                      <td
                        key={api_name}
                        className="px-6 py-4 max-w-32 overflow-x-auto custom-scrollbar"
                      >
                        {order[api_name] || "N/A"}
                      </td>
                    );
                  })}
                  <td className="px-6 py-4 text-center">
                    <span className="flex items-center gap-3 justify-center">
                      <Link
                        to={`/purchase-order/${order?.uid}`}
                        className="text-blue-500 hover:text-blue-700 inline-block"
                      >
                        <Eye />
                      </Link>

                      <button
                        className="cursor-pointer text-red-500"
                        onClick={() => handleDeleteOrder(order.uid)}
                      >
                        <Trash2 />
                      </button>
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={(ORDER_OUTLINE.length ?? 0) + 1}
                  className="text-center py-6 text-orange-500"
                >
                  No Any Drafted Order, Create New Request Order
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default OrderLists;
